<template>
    <el-button type="primary" @click="clickHandler">{{ widget.props.btnText }}</el-button>
</template>

<script>
export default {
    name: "CountButton",
    props: ["value", "widget", "validation", "rules"],
    data() {
        return {
            count: 0
        }
    },
    methods: {
        clickHandler() {
            this.count += 1
            this.$emit("change", this.count)
        }
    }
}
</script>

<style>

</style>